<template>
	<el-card class="table-card" :shadow="shadow">
		<div v-if="$slots.header" slot="header">
			<slot name="header"></slot>
		</div>
		<div class="base-table">
			<div class="table-header">
				<div class="table-left">
					<slot name="header-left"></slot>
				</div>
				<div class="table-operation">
					<slot name="header-right"></slot>
					<!-- 新增 -->
					<el-button v-if="actions.add" size="small" icon="el-icon-plus" type="primary" @click="$emit('add')">
						新增
					</el-button>

					<!-- 导出 -->
					<el-button v-if="actions.export" size="small" icon="el-icon-download" :loading="exportLoading" @click="$emit('export')">
						导出
					</el-button>

					<!-- 导入 -->
					<el-button v-if="actions.import" size="small" icon="el-icon-upload2" :loading="importLoading" @click="$emit('import')">
						批量导入
					</el-button>

					<!-- 自定义按钮 -->
					<slot name="toolbar"></slot>
				</div>
			</div>
			<!-- 表格 -->
			<el-table :data="data" border style="width: 100%" @selection-change="handleSelectionChange" v-loading="loading">
				<el-table-column type="selection" width="50" v-if="selection" align="center" />

				<template v-for="col in columns">
					<el-table-column
						v-if="!col.slot"
						:key="col.prop + '-normal'"
						:prop="col.prop"
						:label="col.label"
						:width="col.width"
						:align="col.align ? col.align : 'center'" />

					<el-table-column
						v-else
						:key="col.prop + '-slot'"
						:label="col.label"
						:width="col.width"
						:align="col.align ? col.align : 'center'">
						<template slot-scope="scope">
							<slot :name="col.slot" :row="scope.row" />
						</template>
					</el-table-column>
				</template>

				<el-table-column v-if="actions.operation && data && data.length" label="操作" width="180" fixed="right">
					<template slot-scope="scope">
						<slot name="operation" :row="scope.row" />
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="table-pagination" v-if="pagination">
				<el-pagination
					background
					layout="sizes, total, prev, pager, next"
					:total="total"
					:page-sizes="[10, 20, 30, 50]"
					:page-size="pageSize"
					:current-page="pageNum"
					@current-change="handlePageChange"
					@size-change="handleSizeChange" />
			</div>
		</div>
	</el-card>
</template>

<script>
	export default {
		name: 'BaseTable',
		props: {
			shadow: {
				type: String,
				default: 'always',
			},
			data: Array,
			columns: Array,
			total: Number,
			pageSize: {
				type: Number,
				default: 1,
			},
			pageNum: {
				type: Number,
				default: 10,
			},
			selection: {
				type: Boolean,
				default: true,
			},
			pagination: {
				type: Boolean,
				default: true,
			},
			loading: {
				type: Boolean,
				default: false,
			},
			exportLoading: {
				type: Boolean,
				default: false,
			},
			importLoading: {
				type: Boolean,
				default: false,
			},
			// ⭐ 按钮控制
			actions: {
				type: Object,
				default: () => ({
					add: false,
					import: false,
					export: false,
					operation: false,
				}),
			},
		},
		methods: {
			handleSearch() {
				this.$emit('search');
			},
			handleReset() {
				this.$emit('reset');
			},
			handlePageChange(page) {
				this.$emit('page-change', page);
			},
			handleSizeChange(size) {
				this.$emit('size-change', size);
			},
			handleSelectionChange(val) {
				this.$emit('selection-change', val);
			},
		},
	};
</script>

<style scoped>
	.table-card {
		margin-bottom: 10px;
	}
	.query-form {
	}

	.table-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 10px;
	}
	.table-left {
		flex: 1;
	}
	.table-operation {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.table-pagination {
		margin-top: 10px;
		display: flex;
		justify-content: flex-end;
	}
</style>
